import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ResourceListComponent} from './resources/resource-list/resource-list.component';
import {ResourceEditComponent} from './resources/resource-edit/resource-edit.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {NgArrayPipesModule, NgBooleanPipesModule, NgObjectPipesModule, NgStringPipesModule} from 'ngx-pipes';
import {InlineSVGModule} from "ng-inline-svg-2";
import {FormsModule} from '@angular/forms';
import {ActionBarModule, MesCommonModule, SystemModule, UserHasPrivilegePipe, WebSharedModule} from 'web-shared';
import {IntegratedMasterEditorComponent} from './integrated-master-editor/integrated-master-editor.component';
import {ManufacturingItemGroupEditComponent} from './manufactured-item-groups/manufacturing-item-group-edit/manufacturing-item-group-edit.component';
import {ProcessEditComponent} from './processes/process-edit/process-edit.component';
import {ProcessEditModalComponent} from './processes/process-edit-modal/process-edit-modal.component';
import {ProcessSelectComponent} from './processes/process-select/process-select.component';
import {ResourceEditStateComponent} from './resources/resource-edit-state/resource-edit-state.component';
import {ResourceEditModalComponent} from './resources/resource-edit-modal/resource-edit-modal.component';
import {ResourceSelectComponent} from './resources/resource-select/resource-select.component';
import {ManufacturingItemSelectComponent} from './manufacturing-item/manufacturing-item-select/manufacturing-item-select.component';
import {ManufacturingItemGroupSelectComponent} from './manufactured-item-groups/manufacturing-item-group-select/manufacturing-item-group-select.component';
import {ManufacturingItemGroupEditStateComponent} from './manufactured-item-groups/manufacturing-item-group-edit-state/manufacturing-item-group-edit-state.component';
import {ManufacturingItemGroupEditModalComponent} from './manufactured-item-groups/manufacturing-item-group-edit-modal/manufacturing-item-group-edit-modal.component';
import {RouterModule} from '@angular/router';
import {CommonSharedModule, EditableModule, HelpModule} from 'common-shared';
import {CostPriceComponentSelectComponent} from './cost-price-components/cost-price-component-select/cost-price-component-select.component';
import {CostPriceComponentEditModalComponent} from './cost-price-components/cost-price-component-edit-modal/cost-price-component-edit-modal.component';
import {CostPriceComponentEditComponent} from './cost-price-components/cost-price-component-edit/cost-price-component-edit.component';
import {MasterUseInstructionEditComponent} from './integrated-master-editor/master-use-instruction-edit/master-use-instruction-edit.component';
import {MasterInputInstructionEditComponent} from './integrated-master-editor/master-input-instruction-edit/master-input-instruction-edit.component';
import {MasterOutputInstructionEditComponent} from './integrated-master-editor/master-output-instruction-edit/master-output-instruction-edit.component';
import {NgbAccordionModule, NgbDatepickerModule, NgbDropdownModule, NgbNavModule, NgbPopoverModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {ManufacturingItemEditComponent} from './manufacturing-item/manufacturing-item-edit/manufacturing-item-edit.component';
import {ManufacturingItemEditMenuButtonsComponent} from './manufacturing-item/manufacturing-item-edit-menu-buttons/manufacturing-item-edit-menu-buttons.component';
import {ManufacturingItemEditModalComponent} from './manufacturing-item/manufacturing-item-edit-modal/manufacturing-item-edit-modal.component';
import {ManufacturingItemEditStateComponent} from './manufacturing-item/manufacturing-item-edit-state/manufacturing-item-edit-state.component';
import {NgxGraphModule} from '@swimlane/ngx-graph';
import {ResourceEditMenuButtonsComponent} from './resources/resource-edit-menu-buttons/resource-edit-menu-buttons.component';
import {IntegratedMasterEditorModalComponent} from './integrated-master-editor/integrated-master-editor-modal/integrated-master-editor-modal.component';
import {ProcessSelectorEditModalComponent} from './integrated-master-editor/process-selector-edit-modal/process-selector-edit-modal.component';
import {ImeSpecLinesViewComponent} from './integrated-master-editor/ime-spec-lines-view/ime-spec-lines-view.component';
import {ImeListComponent} from './ime-list/ime-list.component';
import {ManufacturingItemOrGroupSelectComponent} from './manufacturing-item-or-group-select/manufacturing-item-or-group-select.component';
import {NgOptionHighlightModule} from '@ng-select/ng-option-highlight';
import {TranslocoModule} from "@jsverse/transloco";
import {ProcessListComponent} from "./processes/process-list/process-list.component";
import {TaskSelectorEditModalComponent} from './integrated-master-editor/task-selector-edit-modal/task-selector-edit-modal.component';
import {ManufacturingGraphModalComponent} from "./graph/manufacturing-graph-modal/manufacturing-graph-modal.component";
import {GraphButtonComponent} from './graph/graph-button/graph-button.component';
import {GraphOptionsComponent} from './graph/graph-options/graph-options.component';
import {TableModule} from "primeng/table";
import {NodeLabelPipe} from './graph/manufacturing-graph-modal/node-label.pipe';
import {DragDropModule} from "@angular/cdk/drag-drop";
import {IsAlternativePipe} from './integrated-master-editor/is-alternative.pipe';
import {ManufacturingItemGroupEditMenuButtonsComponent} from './manufactured-item-groups/manufacturing-item-group-edit-menu-buttons/manufacturing-item-group-edit-menu-buttons.component';
import {ExpressionFormulaCellComponent} from './integrated-master-editor/expression-formula-cell/expression-formula-cell.component';
import {ShowByValidConditionPipe} from './integrated-master-editor/show-by-valid-condition.pipe';
import {TaskSelectorCellComponent} from './integrated-master-editor/task-selector-cell/task-selector-cell.component';
import {AceModule} from "ngx-ace-wrapper";
import {IsUserSpecifiedPipe} from './integrated-master-editor/master-use-instruction-edit/is-user-specified.pipe';
import {CostPriceComponentsEditCardComponent} from './cost-price-components/cost-price-components-edit-card/cost-price-components-edit-card.component';
import {ItemTableComponent} from "./manufacturing-item/item-table/item-table.component";
import {ItemListComponent} from './manufacturing-item/item-list/item-list.component';
import {DatasetsEditCardComponent} from './datasets-edit-card/datasets-edit-card.component';
import {ConfigurationDataEditModalComponent} from "./configurations/configuration-data-edit-modal/configuration-data-edit-modal.component";
import {ResourceTableComponent} from './resources/resource-table/resource-table.component';
import {ItemGroupListComponent} from './manufactured-item-groups/item-group-list/item-group-list.component';
import {ItemGroupTableComponent} from './manufactured-item-groups/item-group-table/item-group-table.component';
import {ItemLogComponent} from "./manufacturing-item/item-log/item-log.component";
import {EditItemLogModalComponent} from "./manufacturing-item/item-log/edit-item-log-modal/edit-item-log-modal.component";
import {ItemLogModalComponent} from './manufacturing-item/item-log/item-log-modal/item-log-modal.component';
import {ConfigurationDataEditStateComponent} from './configurations/configuration-data-edit-state/configuration-data-edit-state.component';
import {ConfigurationDataEditComponent} from './configurations/configuration-data-edit/configuration-data-edit.component';
import {GraphBuilderComponent} from './graph/graph-builder/graph-builder.component';
import {GraphBuilderModalComponent} from './graph/graph-builder-modal/graph-builder-modal.component';
import {NodeColorPipe} from "./graph/node-color.pipe";
import {ImeCommonModule} from "../common/ime-common.module";
import {ImeComponentsModule} from "../components/ime-components.module";
import {ItemPickerComponent} from "./manufacturing-item/item-picker/item-picker.component";
import {ResourcePickerComponent} from "./resources/resource-picker/resource-picker.component";
import {ItemGroupDraftsOverviewComponent} from "./publish-drafts/item-group-drafts-overview/item-group-drafts-overview.component";
import {ItemDisplayNameComponent} from './manufacturing-item/item-display-name/item-display-name.component';
import {ItemGroupDisplayNameComponent} from "./manufactured-item-groups/item-group-display-name/item-group-display-name.component";
import {CostPriceComponentListComponent} from './cost-price-components/cost-price-component-list/cost-price-component-list.component';
import {SourceCodeViewComponent} from './integrated-master-editor/source-code-view/source-code-view.component';
import {MasterUseInstructionEditModalComponent} from "./integrated-master-editor/master-use-instruction-edit-modal/master-use-instruction-edit-modal.component";
import {MasterInputInstructionEditModalComponent} from "./integrated-master-editor/master-input-instruction-edit-modal/master-input-instruction-edit-modal.component";
import {MasterOutputInstructionEditModalComponent} from "./integrated-master-editor/master-output-instruction-edit-modal/master-output-instruction-edit-modal.component";

@NgModule({
  imports: [
    AceModule,
    ActionBarModule,
    CommonModule,
    CommonSharedModule,
    DragDropModule,
    EditableModule,
    FormsModule,
    HelpModule,
    ImeCommonModule,
    InlineSVGModule,
    MesCommonModule,
    NgArrayPipesModule,
    NgObjectPipesModule,
    NgOptionHighlightModule,
    NgSelectModule,
    NgStringPipesModule,
    NgbAccordionModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    NgbNavModule,
    NgbPopoverModule,
    NgbTooltipModule,
    NgxGraphModule,
    RouterModule,
    SystemModule,
    TableModule,
    TranslocoModule,
    WebSharedModule,
    ImeComponentsModule,
    ActionBarModule,
    UserHasPrivilegePipe,
    NgBooleanPipesModule
  ],
  exports: [
    ConfigurationDataEditComponent,
    ConfigurationDataEditModalComponent,
    CostPriceComponentEditModalComponent,
    EditItemLogModalComponent,
    GraphButtonComponent,
    GraphOptionsComponent,
    ImeListComponent,
    ImeSpecLinesViewComponent,
    IntegratedMasterEditorComponent,
    IntegratedMasterEditorModalComponent,
    MasterInputInstructionEditComponent,
    MasterInputInstructionEditModalComponent,
    MasterOutputInstructionEditComponent,
    MasterOutputInstructionEditModalComponent,
    IsAlternativePipe,
    ItemGroupListComponent,
    ItemListComponent,
    ItemLogComponent,
    ItemTableComponent,
    ManufacturingGraphModalComponent,
    ManufacturingItemEditComponent,
    ManufacturingItemEditModalComponent,
    ManufacturingItemGroupEditComponent,
    ManufacturingItemGroupEditMenuButtonsComponent,
    ManufacturingItemGroupEditModalComponent,
    ManufacturingItemGroupSelectComponent,
    ManufacturingItemOrGroupSelectComponent,
    ManufacturingItemSelectComponent,
    MasterInputInstructionEditComponent,
    MasterOutputInstructionEditComponent,
    MasterUseInstructionEditComponent,
    ProcessEditModalComponent,
    ProcessSelectComponent,
    ProcessSelectorEditModalComponent,
    ResourceEditModalComponent,
    ResourceSelectComponent,
    ItemPickerComponent,
    ResourcePickerComponent,
    ExpressionFormulaCellComponent,
    ItemGroupDraftsOverviewComponent,
    ItemDisplayNameComponent,
    ItemGroupDisplayNameComponent,
    CostPriceComponentListComponent
  ],
  declarations: [
    ConfigurationDataEditComponent,
    ConfigurationDataEditModalComponent,
    ConfigurationDataEditStateComponent,
    CostPriceComponentEditComponent,
    CostPriceComponentEditModalComponent,
    CostPriceComponentSelectComponent,
    CostPriceComponentsEditCardComponent,
    DatasetsEditCardComponent,
    EditItemLogModalComponent,
    ExpressionFormulaCellComponent,
    GraphBuilderComponent,
    GraphBuilderModalComponent,
    GraphButtonComponent,
    GraphOptionsComponent,
    ImeListComponent,
    ImeSpecLinesViewComponent,
    IntegratedMasterEditorComponent,
    IntegratedMasterEditorModalComponent,
    IsAlternativePipe,
    IsUserSpecifiedPipe,
    ItemGroupListComponent,
    ItemGroupTableComponent,
    ItemListComponent,
    ItemLogComponent,
    ItemLogModalComponent,
    ItemTableComponent,
    ManufacturingGraphModalComponent,
    ManufacturingItemEditComponent,
    ManufacturingItemEditMenuButtonsComponent,
    ManufacturingItemEditModalComponent,
    ManufacturingItemEditStateComponent,
    ManufacturingItemGroupEditComponent,
    ManufacturingItemGroupEditMenuButtonsComponent,
    ManufacturingItemGroupEditModalComponent,
    ManufacturingItemGroupEditStateComponent,
    ManufacturingItemGroupSelectComponent,
    ManufacturingItemOrGroupSelectComponent,
    ManufacturingItemSelectComponent,
    MasterInputInstructionEditComponent,
    MasterInputInstructionEditModalComponent,
    MasterOutputInstructionEditComponent,
    MasterOutputInstructionEditModalComponent,
    MasterUseInstructionEditComponent,
    MasterUseInstructionEditModalComponent,
    NodeColorPipe,
    NodeLabelPipe,
    ProcessEditComponent,
    ProcessEditModalComponent,
    ProcessListComponent,
    ProcessSelectComponent,
    ProcessSelectorEditModalComponent,
    ResourceEditComponent,
    ResourceEditMenuButtonsComponent,
    ResourceEditModalComponent,
    ResourceEditStateComponent,
    ResourceListComponent,
    ResourceSelectComponent,
    ResourceTableComponent,
    ShowByValidConditionPipe,
    TaskSelectorCellComponent,
    TaskSelectorEditModalComponent,
    ItemPickerComponent,
    ResourcePickerComponent,
    ItemGroupDraftsOverviewComponent,
    ItemDisplayNameComponent,
    ItemGroupDisplayNameComponent,
    CostPriceComponentListComponent,
    SourceCodeViewComponent
  ]
})
export class ManufacturingModule {
}
